import { BomDto } from "src/dtos/bom/BomDto";
import { XycoordinateDto } from "src/dtos/xyCoordinate/xyCoordinateDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface KSK2090_R01Dto {
	bomHeaderDto: KSK2090_R01HeaderDto;
	xyCoordinateDetailDtoList: KSK2090_R01DetailDto[];
}

export interface KSK2090_R01HeaderDto extends BomDto {

	itemNm: string;
	itemUnit: string;

	inserted: boolean,
	isModified: boolean,

    
}

/**
 * 생산 실적 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultKSK2090_R01HeaderDto: KSK2090_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '1', // 기본값을 '1'로 설정
	prntItemQty: 1,
	prntItemUnit: 'EA',
	childItemUsage: 0,
	childItemUnit: 'EA',
	fixLossqty: 0,
	materialIntype: 'PURCHASE', // 기본값: 구매
	lossPercent: 0,
	remark: '',

	itemNm: '',
	itemUnit: '',

	inserted: false,
	isModified: false


};

export interface KSK2090_R01DetailDto extends XycoordinateDto {

	childItemnm: string;

	inserted: boolean,
	isModified: boolean,

}

export const defaultKSK2090_R01DetailDto: KSK2090_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	prntItemcd: '',
	coordinateCd: '',
	coordinateNm: '',
	coordinateSeq: 0,
	coordinateUsage: 0,
	xcoordinate: 0,
	ycoordinate: 0,
	orient: 0,
	topBottom: '',
	childItemcd: '',
	applyBeginDt: formatDate(new Date()),
	applyEndDt: formatDate(new Date()),
	afeederCd: '',
	bfeederCd: '',
	cfeederCd: '',
	remark: '',

	childItemnm: '',

	inserted: false,
	isModified: false,
}
